"use client";

import React from "react";
import { FaQuoteLeft, FaStar } from "react-icons/fa";
import Container from "../Container";

const testimonials = [
    {
        quote: "SEOZast saved me hours of keyword research. It’s a game-changer!",
        name: "Alex Rivera",
        role: "Indie Developer",
        avatar: "/images/avatars/alex.png", // Placeholder; replace with real image
    },
    {
        quote: "Finally, an affordable SEO tool that actually works.",
        name: "Priya Sharma",
        role: "Startup CTO",
        avatar: "/images/avatars/priya.png", // Placeholder; replace with real image
    },
    {
        quote: "I used to wast love of time on SEO and pSEO, now I automated everything with SEOZast and I can focus on marketing",
        name: "Liam Chen",
        role: "Freelancer",
        avatar: "/images/avatars/liam.png", // Placeholder; replace with real image
    },
];

const Testimonials = () => {
    return (
        <section className="py-20 bg-gray-100 text-black">
            <Container>
                <h2 className="text-3xl md:text-4xl font-bold text-center mb-12">
                    What Our Users Are Saying
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                    {testimonials.map((testimonial, index) => (
                        <div
                            key={index}
                            className="border-t-4 border-emerald-400 bg-white text-gray-800 p-6 rounded-xl shadow-md hover:shadow-lg transform hover:scale-105 transition-all duration-300"
                        >
                            <FaQuoteLeft className="text-emerald-400 text-2xl mb-4" />
                            <p className="text-black mb-4 leading-relaxed">
                                {testimonial.quote}
                            </p>
                            <div className="flex items-center mb-4">
                                <div className="flex text-yellow-400">
                                    {[...Array(5)].map((_, i) => (
                                        <FaStar key={i} className="w-5 h-5" />
                                    ))}
                                </div>
                            </div>
                            <div className="flex items-center">
                                <img
                                    src={testimonial.avatar}
                                    alt={testimonial.name}
                                    className="w-12 h-12 rounded-full mr-4 object-cover"
                                />
                                <div>
                                    <p className="font-semibold text-black">
                                        {testimonial.name}
                                    </p>
                                    <p className="text-sm text-gray-600">{testimonial.role}</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
                <div className="mt-12 flex justify-center items-center gap-6">
                    <a title="ai tools code.market" href="https://code.market?code.market=verified"><img alt="ai tools code.market" title="ai tools code.market" src="https://code.market/assets/manage-product/featured-logo-bright.svg" /></a>
                    <a href="https://twelve.tools" target="_blank"><img src="https://twelve.tools/badge0-white.svg" alt="Featured on Twelve Tools" width="200" height="54" /></a>
                </div>
            </Container>
        </section>
    );
};

export default Testimonials;